import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import CheckBox from '../../../shared-components/CheckBox/CheckBox';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class PrevAddressCheckbox extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onChange: PropTypes.func
    };

    render() {
        const { intl, onChange } = this.props;

        return (
            <Field
                id="oneYearAddress"
                name="oneYearAddress"
                label={intl.formatMessage({ id: `${LOCALE_PREFIX}.previousAddressShow` })}
                component={CheckBox}
                onChange={onChange}
            />
        );
    }
}

export default injectIntl(PrevAddressCheckbox);
